const NewWindowLoadingPage = () => import("@/core/modules/NewWindowLoadingPage.vue")

export default [
	{
		path: "/app/new-window/loading",
		name: "NewWindowLoadingRoute",
		component: NewWindowLoadingPage,
	},
]
